import { useLocation, useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import { Button, Divider, Drawer, Grid, useTheme } from "@mui/material";
import { tokens } from "../../theme";

import {TextField, Typography, Slider }from '@mui/material';
import Stack from '@mui/material/Stack';
import { CloseRounded, Description } from "@mui/icons-material";

import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';

import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

import env from "react-dotenv";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box className="outer"
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#f2f0f0'),
        // color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        // border: '3px solid',
        //  borderColor: (theme) =>
        //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
        // p: 1,
        //  borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: '500',
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};


const Edit = ({onSelected, open , onClose, onSuccess}) => {
 const navigate = useNavigate();
  const { rowIndex } = useParams();
  const [errors, setErrors] = useState({});
  const [ row , setRow] = useState();
  const [monthyear, setMonthYear] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const submitLockRef = useRef(false);
  const [mainProductsSet, setMainProductsSet] = useState(new Set());
 

  const location = useLocation();
  useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );


  const [data, setData] = useState({
    id:"",
    YearMonth: "",
    ABPB: "0",
    BJRL: "",
    BJTL: "",
    PBS: "",
    RPPS: "",
    RPLBS: "",
    LBS: "",
    TCEJ : "",
    RS: "",
    MEP:"",
  });
  
  // Dynamic product list from main_product
  useEffect(() => {
    const fetchMainProducts = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product`, {
          method: 'GET', headers: { 'Content-Type': 'application/json' },
        });
        const pdata = await res.json();
        const names = new Set();
        const norm = (s) => String(s || '').trim().replace(/\s+/g, ' ').toUpperCase();
        const pushName = (v) => { const n = norm(v); if (n) names.add(n); };
        const keys = ['product','Product','product_name','ProductName','item','Item','item_name','ItemName','name','Name'];
        if (Array.isArray(pdata)) {
          pdata.forEach((row) => {
            if (typeof row === 'string') { pushName(row); return; }
            if (!row || typeof row !== 'object') return;
            keys.forEach((k) => { const val = row[k]; if (typeof val === 'string' && val.trim()) pushName(val); });
          });
        }
        setMainProductsSet(names);
      } catch (e) { setMainProductsSet(new Set()); }
    };
    fetchMainProducts();
  }, []);

  // Build dynamic product fields from main_product; fallback to legacy static list if empty
  const staticFields = ['ABPB','BJRL','BJTL','PBS','RPPS','RPLBS','LBS','TCEJ','RS','MEP'];
  const productFields = Array.from(mainProductsSet);
  productFields.sort((a, b) => a.localeCompare(b));
  const effectiveFields = productFields.length > 0 ? productFields : staticFields;
  const fieldsCol1 = effectiveFields.slice(0, Math.ceil(effectiveFields.length / 2));
  const fieldsCol2 = effectiveFields.slice(Math.ceil(effectiveFields.length / 2));

  const sanitizeToColumn = (name) => String(name || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '_')
    .replace(/[^0-9A-Z_]/g, '_');

  const getFieldValue = (field) => {
    const direct = data?.[field];
    if (direct !== undefined && direct !== null && direct !== '') return direct;
    const alt = sanitizeToColumn(field);
    const v = data?.[alt];
    return v ?? '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const alt = sanitizeToColumn(name);
    setData((prev) => ({
      ...prev,
      [name]: value,
      [alt]: value, // keep sanitized column key in sync for backend
    }));
  }


  const validateForm = () => {
    const errors = {};
    // if (data.WorkType.trim() == 'Machine Maintenance' && !data.Machine.trim()) {
    //     errors.Machine = 'Machine is required if worktype is machine maintenance';
    //     console.log(errors.Machine);
    // }

    return errors;
  };
  function Bar() {
    return (
      <Box
        sx={{
          height: 10,
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? 'rgba(0, 0, 0, 0)'
              : 'rgb(0, 0, 0, 0)',
        }}
      />
    );
  } 
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const modalStyle1 = {
    maxWidth: 600,marginLeft:"330px", marginTop:"30px",
  
    };
    
    const handleSubmitOnDB = async (e) => {
      e.preventDefault();
      if (isSaving || submitLockRef.current) {
        return;
      }
  
      const newErrors = validateForm(data);
      setErrors(newErrors);
      if(monthyear !== null){
        data['YearMonth'] = moment(new Date(monthyear)).format("MMM-yyyy").toString()
      }    
      if (Object.keys(newErrors).length === 0) {
        try{
          submitLockRef.current = true;
          setIsSaving(true);
          const res = await fetch(
            `${process.env.REACT_APP_MISBACKEND_URL}/updateWarranty`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );
          
          onClose();
          onSuccess();
          
        } catch (error) {
          console.log(error);
        } finally {
          submitLockRef.current = false;
          setIsSaving(false);
        }
      }else {
        console.log(`Form submission failed
        due to validation errors.`);
    } 
    };  

    const getDataFromDb = async () => {
      try {
        if (onSelected) {
          const { id, field, dataId} = onSelected;
          const rIndex = dataId;
          setRow(dataId);       
            try { 
                const res = await fetch(
                 `${process.env.REACT_APP_MISBACKEND_URL}/warranty/${rIndex}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );
              const response = await res.json();
              
              setData(response[0]);
            } catch (error) {
              console.log(error);
            }
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    useEffect(() => {
      getDataFromDb(data);   
    }, [onSelected]);
    
    const handleClose = () => {
      navigate("../efficiencyHome/3");   
   
    }

  return (open) ? (
    <Drawer
          anchor="right"
          open={open}
          onClose={onClose}
          PaperProps={{
            sx: {
              width: 730,
              padding: 2,
            }
          }}
        >
        <div style={{ width: "100%",}}  >
          <form style={{ marginLeft:"5px",marginRight:"5px",marginTop:"5px",
          marginBottom:"5px",p: 2,borderRadius: 1}} onSubmit={handleSubmitOnDB}>
           <Typography variant="h4" align="center" color="#4863A0" gutterBottom>
              Update Warranty Record
            </Typography>
          <Divider style={{ marginBottom: '20px' }} />    
          <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(1, 2fr)', gap: 2 ,m:1}}>
                <Item>
                  <FormControl size="medium" fullWidth>
                    <label>YearMonth</label>
                    <DatePicker
                    disabledKeyboardNavigation
                    showMonthYearPicker
                    required
                    value={data.YearMonth}
                    disabled
                    name="YearMonth"
                    selected={monthyear}          
                    className="customInput"
                    popperProps={{
                      positionFixed: true // use this to make the popper position: fixed
                    }}                    
                      autoComplete="off"        
                      onChange={(monthyear) => setMonthYear(new Date(monthyear))}
                      dateFormat="MMM-yyyy"
                    />
                    </FormControl>
                </Item>
          </Box>
         
          <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 2 ,m:1}}>
            <Item>
              <FormControl size="medium" fullWidth>
                {fieldsCol1.map((field) => (
                  <Box key={field}>
                    <label style={{ display: 'block' }}>{field}</label>
                    <TextField
                      size="small"
                      fullWidth
                      value={getFieldValue(field)}
                      name={field}
                      type="number"
                      onChange={handleChange}
                      variant="outlined"
                    />
                    <Bar/>
                  </Box>
                ))}
              </FormControl>
            </Item>
            <Item>
              <FormControl size="medium" fullWidth>
                {fieldsCol2.map((field) => (
                  <Box key={field}>
                    <label style={{ display: 'block' }}>{field}</label>
                    <TextField
                      size="small"
                      fullWidth
                      value={getFieldValue(field)}
                      name={field}
                      type="number"
                      onChange={handleChange}
                      variant="outlined"
                    />
                    <Bar/>
                  </Box>
                ))}
              </FormControl>
            </Item>
          </Box>
          <Divider style={{ marginTop: '20px' }} />    
            <Grid item xs={12} sx={{ marginTop:"20px", display: 'flex', justifyContent: 'center' }}>
              <Button size="large" onClick={() => [onClose(), handleClose()]} color="secondary" sx={{ marginRight: 2,':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    }, }}>
                Cancel
              </Button>
              <Button size="large" disabled={isSaving} onClick={handleSubmitOnDB}  sx={{backgroundColor:'#4863A0',':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    },}} variant="contained">
                Save
              </Button>            
            </Grid>

        </form>
    </div>
    </Drawer>
  ) : "";
};

export default Edit;